import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { getAiInterviewRankings } from 'store/Recruitment/actions'
import WatchInterviewComponent from './ApplicationDetails/WatchInterviewComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { resetAiInterviewState } from 'store/Recruitment/actions'

function AiInterviewRankings() {
  const dispatch = useDispatch()
  const { aiInterviewRankings, jobProps } = useSelector(
    (store) => store.recruitment
  )

  const [watchInterview, setWatchInterview] = useState(false)
  const [interviewData, setInterviewData] = useState(null)

  useEffect(() => {
    dispatch(
      getAiInterviewRankings(
        jobProps?.find((item) => item?.name === 'id')?.value
      )
    )
  }, [dispatch, jobProps])

  const columns = [
    {
      headerName: 'Name',
      resizable: true,
      field: 'name',
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Email',
      field: 'email',
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Score',
      field: 'average_score',
      sortable: true,
      unSortIcon: true,
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: '',
      field: 'interview_link',
      flex: 1,
      cellRenderer: (params) =>
        params.value ? (
          <button
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () => {
                    dispatch(
                      resetAiInterviewState(
                        params.data.interview_id,
                        jobProps?.find((item) => item?.name === 'id')?.value
                      )
                    )
                  },
                })
              )
            }
            className='btn btn-danger mb-1'
          >
            Reset AI Interview{' '}
            <FontAwesomeIcon icon={faArrowsRotate} className='ml-2' />
          </button>
        ) : null,
    },
    {
      headerName: '',
      field: 'interview_link',
      cellRenderer: (params) =>
        params.value ? (
          <button
            onClick={() => {
              setInterviewData({
                id: params.data.interview_id,
                link: params.value,
                timestamps: params.data.timestamps,
              })
              setWatchInterview(true)
            }}
            className='btn btn-info mb-1'
          >
            Watch Interview
          </button>
        ) : null,
    },
  ]

  if (watchInterview && interviewData) {
    return (
      <WatchInterviewComponent
        interviewData={interviewData}
        onClose={() => {
          setWatchInterview(false)
          setInterviewData(null)
        }}
      />
    )
  }

  return (
    <>
      <Card>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact columnDefs={columns} rowData={aiInterviewRankings} />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default AiInterviewRankings
